<template>
  <div class="user">
    <div v-if="user">
      <router-link :to="routerLink">
        <div class="avatar">
          <svg id="icon-x" v-if="isProfilePage" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6l12 12" stroke="#FFF8F2" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg id="icon-user" v-else width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"
              stroke="#FFF8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </router-link>
      <div class="mode">
        <div v-if="user.isAdmin">
          {{getMode}}
          <a @click="toggleMode">
            Switch
          </a>
        </div>
        <div v-else>
          Profile
        </div>
      </div>
    </div>
    <div class="links" v-else>
      <router-link :to="{name: 'Login'}">
        Log In
      </router-link>
      <span class="u-desktop-only">&middot;</span>
      <router-link class="u-desktop-only" :to="{name: 'Login'}">
        Sign Up
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserActions',
  computed: {
    ...mapGetters(['getUser', 'getMode']),
    user() {
      return this.getUser;
    },
    isProfilePage() {
      return this.$route.name === 'Profile';
    },
    routerLink() {
      const name = this.isProfilePage ? 'Home' : 'Profile';
      return { name };
    },
    newMode() {
      return this.getMode === 'admin' ? 'reader' : 'admin';
    },
  },
  methods: {
    toggleMode() {
      if (this.newMode === 'admin') {
        this.$router.push({ name: 'CalendarMonth' });
      } else {
        this.$router.push({ name: 'Home' });
      }
      this.$store.dispatch('set', {
        model: 'mode',
        value: this.newMode,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.user {
  text-align: right;
  position: relative;
  .avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: var(--color-dark);
    color: var(--color-light);
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: var(--color-link);
    }
  }
  .u-desktop-only {
    @media all and (max-width: 600px) {
      display: none;
    }
  }
  .links {
    a {
      margin: 0 5px;
    }
  }
  .mode {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: calc(100% + 10px);
    text-align: right;
    font-size: var(--font-small);
    text-transform: capitalize;
    font-weight: 500;
    a, span {
      color: var(--color-link-inactive);
    }
    @media all and (max-width: 600px) {
      display: none;
    }
  }
}
</style>
